export default __webpack_public_path__ + "static/media/STORIES-BEAN-BAG.9ff71c36.png";